import React from 'react';

import "./table.scss"
import LoadingContainer from "../common/loading/LoadingContainer";
import LoadingOval from "../common/loading/LoadingOval";
import {useNavigate} from "react-router-dom";

const ProductsTable = ({items, loading, footer}) => {

    const navigate = useNavigate();

    const handleTableRowClick = (product) => {
        navigate("./" + product.id + "/edit")
    }

    return (
        <div>
            <table className="Table">
                <thead>
                <tr>
                    <td className="Table__header-data">
                        <div className="Table__data-container">
                            <span>
                                Image
                            </span>
                        </div>
                    </td>
                    <td className="Table__header-data">
                        <div className="Table__data-container">
                            <span>
                                Title
                            </span>
                        </div>
                    </td>
                    <td className="Table__header-data">
                        <div className="Table__data-container">
                            <span>
                                Category
                            </span>
                        </div>
                    </td>
                    <td className="Table__header-data">
                        <div className="Table__data-container">
                            <span>
                                Price (USD)
                            </span>
                        </div>
                    </td>
                </tr>
                </thead>
                {loading === false &&
                    <tbody>
                    {items && items.map(item =>
                        <tr className="Table__row" key={item.id} onClick={() => handleTableRowClick(item)}>
                            <td className="Table__body-data Table__body-data__image Table__product-body-data__image">
                                <div className="Table__data-container">
                                    <div className="Table__image-container Table__product-image-container">
                                        <img className="Table__image Table__product-cover-image" src={item.getMainImageUrl()}/>
                                        <div className="Table_image-overlay"/>
                                    </div>
                                </div>
                            </td>
                            <td className="Table__body-data">
                                <div className="Table__data-container">
                            <span className="Table__primary-text-span Table__two-lines-span">
                                {item.getTitle()}
                            </span>
                                </div>
                            </td>
                            <td className="Table__body-data">
                                <div className="Table__data-container">
                            <span className="Table__secondary-text-span Table__two-lines-span">
                                {item.getCategoryTitle()}
                            </span>
                                </div>
                            </td>
                            <td className="Table__body-data">
                                <div className="Table__data-container">
                            <span className="Table__secondary-text-span">
                                {item.getPriceInUSD()}
                            </span>
                                </div>
                            </td>
                        </tr>
                    )}
                    </tbody>
                }
            </table>
            {loading === true &&
                <LoadingContainer>
                    <LoadingOval loading={loading}/>
                </LoadingContainer>
            }
            { footer !== undefined && footer }
        </div>
    );
};

export default ProductsTable;